import { FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from "../i18n";

export const ALLOWED_THEMES = ["system", "light", "dark"];
export const ALLOWED_FONT_SIZES = ["small", "medium", "large"];
export const ALLOWED_LANGUAGES = SUPPORTED_LANGUAGES;

export const DEFAULT_SETTINGS = Object.freeze({
    privacy: {
        showActivityStatus: true,
        allowDataCollection: false,
    },
    security: {
        twoFactorEnabled: false,
    },
    appearance: {
        theme: "system",
        fontSize: "medium",
        language: FALLBACK_LANGUAGE,
    },
});

const toBoolean = (value, fallback) => (typeof value === "boolean" ? value : fallback);

const sanitizeChoice = (value, allowedValues, fallback) => {
    if (typeof value !== "string") {
        return fallback;
    }
    const trimmed = value.trim().toLowerCase();
    return allowedValues.includes(trimmed) ? trimmed : fallback;
};

export const normalizeSettings = (settings = {}) => ({
    privacy: {
        showActivityStatus: toBoolean(
            settings?.privacy?.showActivityStatus,
            DEFAULT_SETTINGS.privacy.showActivityStatus,
        ),
        allowDataCollection: toBoolean(
            settings?.privacy?.allowDataCollection,
            DEFAULT_SETTINGS.privacy.allowDataCollection,
        ),
    },
    security: {
        twoFactorEnabled: toBoolean(
            settings?.security?.twoFactorEnabled,
            DEFAULT_SETTINGS.security.twoFactorEnabled,
        ),
    },
    appearance: {
        theme: sanitizeChoice(settings?.appearance?.theme, ALLOWED_THEMES, DEFAULT_SETTINGS.appearance.theme),
        fontSize: sanitizeChoice(
            settings?.appearance?.fontSize,
            ALLOWED_FONT_SIZES,
            DEFAULT_SETTINGS.appearance.fontSize,
        ),
        language: sanitizeChoice(
            settings?.appearance?.language,
            ALLOWED_LANGUAGES,
            DEFAULT_SETTINGS.appearance.language,
        ),
    },
});

export const buildSettingsPayload = (settings) => {
    const normalized = normalizeSettings(settings);
    return {
        privacy: { ...normalized.privacy },
        appearance: { ...normalized.appearance },
    };
};
